export const lineHeights = {
  base: 1.25
};
